export default __webpack_public_path__ + "86b800871a44466018b4aaf1dfbe3079.svg";